/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssetClass } from './AssetClass';
import {
    AssetClassFromJSON,
    AssetClassFromJSONTyped,
    AssetClassToJSON,
} from './AssetClass';
import type { AssetType } from './AssetType';
import {
    AssetTypeFromJSON,
    AssetTypeFromJSONTyped,
    AssetTypeToJSON,
} from './AssetType';

/**
 * A held position the trading universe excludes by its asset class / type (EXCLUDED convictions are not these). Keyed by the broker
 * account id (custody type and id): the snapshot is T-1 and fixed on the broker side, while the account guid follows the live configuration.
 * @export
 * @interface UniverseExcludedPosition
 */
export interface UniverseExcludedPosition {
    /**
     * 
     * @type {string}
     * @memberof UniverseExcludedPosition
     */
    sId: string;
    /**
     * 
     * @type {string}
     * @memberof UniverseExcludedPosition
     */
    scId?: string;
    /**
     * 
     * @type {string}
     * @memberof UniverseExcludedPosition
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof UniverseExcludedPosition
     */
    symbol?: string;
    /**
     * 
     * @type {AssetClass}
     * @memberof UniverseExcludedPosition
     */
    assetClass?: AssetClass;
    /**
     * 
     * @type {AssetType}
     * @memberof UniverseExcludedPosition
     */
    assetType?: AssetType;
    /**
     * 
     * @type {number}
     * @memberof UniverseExcludedPosition
     */
    currentExposure: number;
    /**
     * 
     * @type {string}
     * @memberof UniverseExcludedPosition
     */
    brokerAccountId: string;
}



/**
 * Check if a given object implements the UniverseExcludedPosition interface.
 */
export function instanceOfUniverseExcludedPosition(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sId" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "currentExposure" in value;
    isInstance = isInstance && "brokerAccountId" in value;

    return isInstance;
}

export function UniverseExcludedPositionFromJSON(json: any): UniverseExcludedPosition {
    return UniverseExcludedPositionFromJSONTyped(json, false);
}

export function UniverseExcludedPositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): UniverseExcludedPosition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sId': json['s_id'],
        'scId': !exists(json, 'sc_id') ? undefined : json['sc_id'],
        'description': json['description'],
        'symbol': !exists(json, 'symbol') ? undefined : json['symbol'],
        'assetClass': !exists(json, 'asset_class') ? undefined : AssetClassFromJSON(json['asset_class']),
        'assetType': !exists(json, 'asset_type') ? undefined : AssetTypeFromJSON(json['asset_type']),
        'currentExposure': json['current_exposure'],
        'brokerAccountId': json['broker_account_id'],
    };
}

export function UniverseExcludedPositionToJSON(value?: UniverseExcludedPosition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        's_id': value.sId,
        'sc_id': value.scId,
        'description': value.description,
        'symbol': value.symbol,
        'asset_class': AssetClassToJSON(value.assetClass),
        'asset_type': AssetTypeToJSON(value.assetType),
        'current_exposure': value.currentExposure,
        'broker_account_id': value.brokerAccountId,
    };
}

